import Reactor from '../reactor';

const STORE_TERMS = 'STORE_TERMS';
const STORE_CURRENT_ACADEMIC_YEAR = 'STORE_CURRENT_ACADEMIC_YEAR';
const STORE_RIT_QUINTILES = 'STORE_RIT_QUINTILES';
const STORE_DISTRICT_AVERAGES = 'STORE_DISTRICT_AVERAGES';
const STORE_LINKING_STUDIES_FOR_PARTNER = 'STORE_LINKING_STUDIES_FOR_PARTNER';

export default {
    STORE_TERMS,
    STORE_CURRENT_ACADEMIC_YEAR,
    STORE_RIT_QUINTILES,
    STORE_DISTRICT_AVERAGES,
    STORE_LINKING_STUDIES_FOR_PARTNER,

    storeTermsInformation: (response) => {
        Reactor.dispatch(STORE_TERMS, response);
    },
    storeCurrentAcademicYearInformation: (response) => {
        Reactor.dispatch(STORE_CURRENT_ACADEMIC_YEAR, response);
    },
    storeRitQuintiles: (data) => {
        Reactor.dispatch(STORE_RIT_QUINTILES, data);
    },
    storeDistrictAverages: (averages) => {
        Reactor.dispatch(STORE_DISTRICT_AVERAGES, averages);
    },
    storeLinkingStudiesForPartner: (studies) => {
        Reactor.dispatch(STORE_LINKING_STUDIES_FOR_PARTNER, studies);
    },
};
